import { SphereButton } from "@components/common/sphere-button";
import { FaroButtonContained } from "@components/common/faro-button-contained";
import { useMediaQueryList } from "@hooks/use-media-query";

interface Props {
  /** Determines the variant of the invite member button */
  buttonVariant?: "outlined" | "filled";

  /** Callback fired when the button is clicked */
  onClick: () => void;

  /** If true, button width is always "auto" regardless of screen size */
  shouldUseAutoWidth?: boolean;
}

/**
 * Reusable invite member button component.
 * Renders either a filled SphereButton or outlined FaroButtonContained based on variant.
 */
export function InviteMemberButton({
  buttonVariant = "outlined",
  onClick,
  shouldUseAutoWidth = false,
}: Props): JSX.Element {
  const { isScreenLgOrLarger } = useMediaQueryList();

  if (buttonVariant === "filled") {
    const width = !shouldUseAutoWidth && !isScreenLgOrLarger ? "100%" : "auto";
    return (
      <SphereButton onClick={onClick} sx={{ width }}>
        Invite members
      </SphereButton>
    );
  }

  return (
    <FaroButtonContained onClick={onClick}>Invite members</FaroButtonContained>
  );
}
